import React from 'react';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import s from './ContentTextRenderer.scss';
const ContentTextRenderer = ({ comment })=>{
    const { commentId, textContent } = comment;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(TextRenderer, {
        className: s['renderer'],
        textContent: textContent,
        reactViewer: CommentViewer,
        legacyTheme: 'comments',
        viewerKey: commentId
    }));
};
ContentTextRenderer.displayName = 'ContentTextRenderer';
export default ContentTextRenderer;

//# sourceMappingURL=ContentTextRenderer.js.map